import { connect } from 'react-redux'

import DifferentActivitiesList from 'app/domains/common/DifferentActivitiesList'
import withDidMountRequest from 'app/connectors/withDidMountRequest'
import { getUpcomingActivities, getUpcomingActivitiesLoadStatus } from 'store/entities/differentActivities/selectors'
import { getUpcomingActivities as getUpcomingActivitiesRequest } from 'store/entities/differentActivities/actions'

const mapDispatchToProps = dispatch => ({
  onRequest() {
    if (!this.props.loaded) {
      dispatch(getUpcomingActivitiesRequest())
    }
  },
})

const mapStateToProps = state => ({
  activities: getUpcomingActivities(state),
  loaded: getUpcomingActivitiesLoadStatus(state),
  acitivitiesManText: "You don't have any upcoming activities",
})

export default connect(mapStateToProps, mapDispatchToProps)(withDidMountRequest(DifferentActivitiesList))
